<template>
  <app-base-main
      no-padding
      parentTable
      :table-shadow="false">
    <template #filter-group>
      <app-filter-group
          :reset="false"
          @query="$gjNoticeQuery">
        <gj-supplier-select
            v-model="filter.code"
            placeholder="供应商"
            width="200px"
        ></gj-supplier-select>
        <gj-date-picker
            v-model="filter.createDate"
            tooltip="创建时间"
            type="daterange"
        ></gj-date-picker>
      </app-filter-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          name="productOffer"
          :index="false"
          border
          :loading="loading"
          :data="tableData"
          :columns="columns"
          :offset-height="58"
          :structure-config="{type: 'ParentChildTree', children: 'items', spanType: 'row', parentSpan: ['0-5', 12]}"
          :default-sort="{prop: 'createTime', order: 'descending'}"
          @sort-change="$gjSortChange">
        <template v-slot:supplier="{row}">
          <div>{{row.supplierCode | defaultShow}}</div>
          <div>{{row.name | defaultShow}}</div>
        </template>
        <template v-slot:purchaseUrl="{row}">
          <template v-if="isMeaningful(row.purchaseUrl)">
            <gj-link :href="row.purchaseUrl | href" target="_blank">{{row.purchaseUrl | defaultShow}}</gj-link>
          </template>
          <template v-else>-</template>
        </template>
        <template v-slot:op="{row}">
          <gj-button
              type="text"
              @click="offer(row)">
            报价
          </gj-button>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {isMeaningfulMixin, queryMixin} from "../../../../../../minxins";
  import AppProductOfferModal from "./product-offer-modal";
  import {convertToDate} from "../../../../../../utils/date.util";
  import {getSupplierQuoteList} from "../../../../../../api/product";
  export default {
    name: "app-product-offer-form",
    mixins: [queryMixin, isMeaningfulMixin],
    props: {
      form: {
        required: true
      },
      mountTo: {
        required: true
      }
    },
    filters: {
      href(data) {
        if (data.includes('http') || data.includes('https')) {
          return data;
        } else {
          return `http://${data}`;
        }
      }
    },
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'supplier', header: '供应商编码/名称', field: 'slot:supplier', minWidth: '145px', fixed: 'left'},
          {id: 'status', header: '状态', field: 'option(plain):status', width: '65px',
            options: [
              {id: 'enable', text: '启用'},
              {id: 'disable', text: '禁用', color: 'red'},
            ]},
          {id: 'moq', header: '最小起订量', field: 'moq', width: '90px', align: 'right'},
          {id: 'purchaseDeliveryDays', header: '采购交期(天)', field: 'purchaseDeliveryDays', width: '100px', align: 'right'},
          {id: 'purchaseUrl', header: '产品网址', field: 'slot:purchaseUrl', width: '145px'},
          {id: 'currency', header: '币种', field: 'currency', width: '58px'},
          {id: 'excludeTaxPrice', header: '不含税单价', field: 'excludeTaxPrice', width: '85px', align: 'right'},
          {id: 'includeTaxPrice', header: '含税单价', field: 'includeTaxPrice', width: '80px', align: 'right'},
          {id: 'invoiceTaxRate', header: '票面税率(%)', field: 'invoiceTaxRate', suffix: '%', width: '100px', align: 'right'},
          {id: 'actualTaxRate', header: '实际税率(%)', field: 'actualTaxRate', suffix: '%', width: '100px', align: 'right'},
          {id: 'createTime', header: '创建时间', field: 'createTime', width: '100px', sortable: true},
          {id: 'op', header: '操作', field: 'slot:op', width: '50px', fixed: 'right', permission: 'product:addQuote'},
        ],
        filter: {
          code: null,
          createDate: null,
        },
      }
    },
    methods: {
      $gjQueryInitParams() {
        return {
          filter: {
            code: null,
            createDate: null
          }
        };
      },
      $gjQuery() {
        this.loading = true;
        // 构造查询参数
        const params = {
          model: {
            sku: this.form.sku,
            code: this.filter.code,
            startCreateTime: this.filter.createDate ? convertToDate(this.filter.createDate[0]) : null,
            endCreateTime: this.filter.createDate ? convertToDate(this.filter.createDate[1]) : null,
          },
          current: 1,
          size: 999999,
        };
        // 查询
        this.loading = true;
        getSupplierQuoteList(params)
          .then(data => {
            data.records.forEach(item => {
              item.items = [item].concat(item.quoteHistoryList || []);
            });
            this.tableData = data.records;
          })
          .complete(() => this.loading = false);
      },
      offer(item) {
        this.$gjCreate(AppProductOfferModal, {
          mountTo: this.mountTo,
          props: {
            offer: item,
            product: {
              name: this.form.name,
              sku: this.form.sku,
            }
          },
          on: {
            created: () => {
              this.$gjResetPage();
            }
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
